import {course_getCourses_Api} from 'apis'
import React, {useContext} from 'react'
import {renderCourse} from 'views/Workspace/Course/functions/renderCourse'
import {renderCourseCompact} from "../../../Workspace/Course/functions/renderCourse";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import renderPagingLoading from "../../../MainPage/functions/renderPagingLoading";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

const Pager = ({renderItem = renderCourse(), apiInfo = course_getCourses_Api, ...props}) => {

    const {isSm} = useContext(LayoutContext)

    return (
        <CustomLazyPaginationWrapper
            sample={2}
            apiInfo={apiInfo}
            renderItem={renderCourseCompact({showOrg: false})}
            renderLoading={renderPagingLoading}
            {...props}
        />
    )
}

export const OpeningCourses = ({
                                   query,
                                   values,
                                   apiInfo,
                                   renderItem,
                                   ...props
                               }) => (
    <Pager
        {...{query, values, apiInfo, renderItem}}
        {...props}
    />
)
